export default __webpack_public_path__ + "images/05f34cba9f5046bae812ba86eac0e303.png";